module.exports = __webpack_public_path__ + "src/assets/img/navlogo--dsk.dbe17375.png";